<div class="filter">
  <ng-container>
    <app-search-bar [showPrimaryBtn]="false" [sortFields]="sortFields" [showFilterBtn]="true"
      (onFilterBtnClick)="showDialog()" (formValueChange)="handleFormValueChange($event)"></app-search-bar>
  </ng-container>
  <div *ngIf="pagination?.data?.length; else emptyData">
    <p-table [value]="pagination.data || []" stripedRows="true">
      <ng-template pTemplate="header">
        <tr>
          <th>Bilhete de Identidade</th>
          <th>Nome do Profissional</th>
          <th>Função de Referência</th>
          <th>Habilitação Académica</th>
          <th>Estado</th>
          <th>Empresa</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-profissional>
        <tr (click)="showDetail(profissional)" class="cursor-pointer">
          <td>{{ textToUpper(profissional.numBI) }}</td>
          <td>{{ profissional.nome }}</td>
          <td>{{ profissional.especialidadesFuncoes || 'Sem Profissão' }}</td>
          <td>{{ profissional.nivelHabilitacao || 'Sem Habilitações' }}</td>
          <td>
            <p-tag *ngIf="profissional.estado === 'Empregado'" severity="success" value="Empregado"></p-tag>
            <p-tag *ngIf="profissional.estado === 'Desempregado'" severity="warn" value="Desempregado"></p-tag>
            <p-tag *ngIf="profissional.estado === ''" severity="warn" value="Desempregado"></p-tag>
          </td>
          <td>{{ profissional.empresa || 'Sem Empresa' }}</td>
          <!-- <td>
            <div class="flex justify-center">
              <p-menu #menu [model]="getMenuItems(profissional)" [popup]="true" appendTo="body"></p-menu>
              <p-button (click)="menu.toggle($event)" icon="pi pi-ellipsis-v"></p-button>
            </div>
          </td> -->
        </tr>
      </ng-template>
    </p-table>
    <div class="pagination-controls">
      <app-paginator-control [first]="
            ((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)
          " [rows]="pagination.pageSize ?? 10" [totalRecords]="pagination.totalRecords ?? 0"
        (pageChange)="onPageChange($event)">
      </app-paginator-control>
    </div>
  </div>
  <ng-template #emptyData>
    <div class="no-data">
      <app-data-void titulo="Nenhum profissional encontrado"
        descricao="Os profissionais associados a si no SIASP que aparecerão aqui."></app-data-void>
    </div>
  </ng-template>

  <p-drawer [(visible)]="visible" position="right" [style]="{'width': '720px'}"
    styleClass="!w-full md:!w-80 lg:!w-[30rem]">
    <ng-template #headless>
      @if (profissional) {
      <app-detalhe-profissionais [profissional]="profissional" (onCloseModal)="visible=false" />
      }
    </ng-template>
  </p-drawer>

  <p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">

    <form [formGroup]="form" class="p-fluid grid">
      <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
        <label>{{ filter.placeholder }}</label>

        <!-- Se for dropdown -->
        <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
          [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
          [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue">
        </p-select>

        <!-- Se for texto -->
        <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
          [placeholder]="filter.placeholder" class="w-full" />
      </div>
    </form>

    <div class="flex items-center justify-content-between">
      <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
      <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
    </div>
  </p-dialog>

<p-toast></p-toast>
